module.exports = __webpack_public_path__ + "img/md-bicycle.c93a92ab.svg";